module.exports = __webpack_public_path__ + "static/media/CI&TLogo.9193b67a.png";